import React from 'react';
import { Container } from '../../atoms/container/Container';
import { Text } from '../../atoms/text/Text';
import { Flex } from 'antd';
import style from './AmbulancePickupTime.module.scss';

interface AmbulancePickupTimeProps {
    ambulancePickupTime: string;
    handleAmbulancePickupTime: (value: string) => void;
    disable?: boolean
}

export const AmbulancePickupTime: React.FC<AmbulancePickupTimeProps> = ({ ambulancePickupTime, handleAmbulancePickupTime, disable }) => {
    return (
        <Container className={style.horizon_wrapper}>
            <Container className={style.label}>
                <Text text="Pickup Time:" className={style.title} />
            </Container>
            <Container className={style.input_wrapper}>
                <Flex gap={10} align="center">
                    <input
                        type="datetime-local"
                        value={ambulancePickupTime}
                        onChange={(e) => handleAmbulancePickupTime(e.target.value)}
                        placeholder="Select Pickup Time"
                        disabled={disable}
                    />
                </Flex>
            </Container>
        </Container>
    )
}